<span class="_priceSection position-relative">
  <button class="favourite-button" (click)="toggleSelected()">
    <i *ngIf="!selectedFav" class="far fa-heart fa-2x text-dark"></i>
    <i *ngIf="selectedFav" class="fa fa-heart fa-2x text-danger"></i>

  </button>

</span>

